module.exports = "https://web-assets.ifttt.com/packs/media/docs/brand_logo-ed8a55a3.png";